export default "__VITE_ASSET__C6pD$7q___"